export const investorTexts = {
  fr: {
    potentiel: 'Potentiel',
    licorne: 'SCALE-UP',
    gmvLabel: 'GMV 1,79 MILLIARD $',
    syntheseInvestisseur: 'Synthèse Investisseur',
    planComplet: 'Le plan complet en 2 minutes',
    autonomieFinanciere: "Le financement initial (250K$) couvre exclusivement la phase de mise en operation (M0-M6). Des le mois 6-7, EcoLunch atteint l'equilibre puis une rentabilite operationnelle, permettant de financer l'ensemble de ses operations et de sa croissance sans recours a du financement externe additionnel. Tout financement futur serait non requis mais opportuniste, visant a accelerer la croissance ou securiser des leviers strategiques.",
    marcheFragmenteTitre: 'Le Marché Fragmenté - Notre Avantage Stratégique',
    marcheP1: "Le marché canadien des repas scolaires fonctionne encore comme un écosystème éclaté : chaque traiteur opère isolément, avec peu de moyens technologiques et un volume insuffisant pour justifier l'investissement dans une plateforme moderne. Résultat : aucune infrastructure numérique de pointe n'a jamais pu émerger, laissant les écoles coincées avec des processus archaïques, une gestion manuelle lourde et des contrats de gré à gré sans véritable contrôle.",
    marcheP2: "Alors que la demande pour des solutions modernes, intégrées et conformes aux exigences financières augmente rapidement, il n'existe aucune solution multi-traiteurs capable d'unifier, standardiser et professionnaliser l'ensemble du système. Cette absence de plateforme commune crée une inefficacité structurelle majeure — et une opportunité rare.",
    marcheRevolution: "EcoLunch introduit précisément la révolution que le marché attend",
    marcheDescription: "Elle introduit le premier système multi-traiteurs du marché canadien — une plateforme SaaS + FinTech capable d'offrir aux traiteurs la technologie qu'ils ne pourraient jamais développer seuls, tout en donnant aux écoles un modèle transparent, contrôlable et incroyablement plus simple à gérer.",
    marcheConclusion: "C'est une opportunité unique : résoudre un problème systémique que personne ne peut régler seul, mais qu'une plateforme intelligente peut convertir en nouveau standard national. En fédérant tous les acteurs autour d'une infrastructure centralisée, EcoLunch transformera un marché fragmenté en un réseau cohérent, capturant inévitablement une position de leader incontesté.",
    opportuniteUnique: 'OPPORTUNITÉ UNIQUE',
    opportunite: "L'Opportunité",
    probleme: 'Problème',
    problemeDesc: 'Fragmentation, UX datée, double saisie, faible gouvernance',
    solution: 'Solution',
    solutionDesc: 'Plateforme unifiée SaaS + FinTech 100% Québec',
    marche: 'Marché',
    marcheDesc: '7 206 écoles ciblées (10 provinces + 575 privé) sur 12 705 TAM',
    leModele: 'Le Modèle',
    gmv5ans: 'GMV 5 ans',
    revenus5ans: 'Revenus 5 ans',
    baiia5ans: 'BAIIA 5 ans',
    takeRate: 'Take-rate 2,76%',
    marge80: 'Marge ~90%',
    laTraction: 'La Traction',
    objectifs5ans: 'Objectifs 5 ans',
    ecolesQuebec: 'écoles Québec',
    ecolesOntario: 'écoles Ontario',
    ecolesBC: 'écoles C.-B.',
    ecolesAlberta: 'écoles Alberta',
    ecolesTotal: 'écoles TOTAL',
    jalonsTitle: 'Jalons clés',
    centPourcentQC: '100% Québec',
    hebergementQC: 'Hébergement, paiements (SonaPay), données + Messagerie RBAC',
    investissement: "L'Investissement",
    leveesFonds: 'Levées de fonds',
    launch: 'Launch',
    postLaunch: 'Post-launch',
    serieA2: 'Série A2',
    pourquoiLicorne: 'Pourquoi licorne ?',
    gmvProuve: 'GMV prouve capacité à générer +1B$ volume',
    useFunds: 'Utilisation des fonds',
    devProduit: 'Développement produit',
    salesMarketing: 'Sales & Marketing',
    infraSecurity: 'Infrastructure & Sécurité',
    opsSupport: 'Opérations & Support'
  },
  en: {
    potentiel: 'Potential',
    licorne: 'SCALE-UP',
    gmvLabel: 'GMV 1.79 BILLION $',
    syntheseInvestisseur: 'Investor Summary',
    planComplet: 'The complete plan in 2 minutes',
    autonomieFinanciere: "Initial funding (100K$) covers exclusively the operational setup phase (M0-M6). As of month 6-7, EcoLunch reaches break-even then operational profitability, enabling it to fund all operations and growth without additional external financing. Any future funding would be non-required but opportunistic, aimed at accelerating growth or securing strategic levers.",
    marcheFragmenteTitre: 'The Fragmented Market - Our Strategic Advantage',
    marcheP1: "The Canadian school meal market still operates as a fragmented ecosystem: each caterer operates in isolation, with limited technological means and insufficient volume to justify investment in a modern platform. Result: no state-of-the-art digital infrastructure has ever emerged, leaving schools stuck with archaic processes, heavy manual management, and uncontrolled case-by-case contracts.",
    marcheP2: "While demand for modern, integrated solutions compliant with financial requirements is rapidly increasing, there is no multi-caterer solution capable of unifying, standardizing, and professionalizing the entire system. This absence of a common platform creates major structural inefficiency — and a rare opportunity.",
    marcheRevolution: "EcoLunch introduces precisely the revolution the market awaits",
    marcheDescription: "It introduces the first multi-caterer system in the Canadian market — a SaaS + FinTech platform capable of offering caterers technology they could never develop alone, while giving schools a transparent, controllable, and incredibly simpler model to manage.",
    marcheConclusion: "This is a unique opportunity: solving a systemic problem that no one can fix alone, but that an intelligent platform can convert into a new national standard. By federating all actors around centralized infrastructure, EcoLunch will transform a fragmented market into a coherent network, inevitably capturing an undisputed leadership position.",
    opportuniteUnique: 'UNIQUE OPPORTUNITY',
    opportunite: "The Opportunity",
    probleme: 'Problem',
    problemeDesc: 'Fragmentation, outdated UX, double entry, weak governance',
    solution: 'Solution',
    solutionDesc: 'Unified SaaS + FinTech platform 100% Quebec',
    marche: 'Market',
    marcheDesc: '7,206 target schools (10 provinces + 575 private) out of 12,705 TAM',
    leModele: 'The Model',
    gmv5ans: '5-year GMV',
    revenus5ans: '5-year Revenue',
    baiia5ans: '5-year EBITDA',
    takeRate: 'Take-rate 2.76%',
    marge80: '~90% Margin',
    laTraction: 'The Traction',
    objectifs5ans: '5-year Goals',
    ecolesQuebec: 'Quebec schools',
    ecolesOntario: 'Ontario schools',
    ecolesBC: 'BC schools',
    ecolesAlberta: 'Alberta schools',
    ecolesTotal: 'TOTAL schools',
    jalonsTitle: 'Key Milestones',
    centPourcentQC: '100% Quebec',
    hebergementQC: 'Hosting, payments (SonaPay), data + RBAC Messaging',
    investissement: "The Investment",
    leveesFonds: 'Funding Rounds',
    launch: 'Launch',
    postLaunch: 'Post-launch',
    serieA2: 'Series A2',
    pourquoiLicorne: 'Why Unicorn?',
    gmvProuve: 'GMV proves capacity to generate +$1B volume',
    useFunds: 'Use of Funds',
    devProduit: 'Product Development',
    salesMarketing: 'Sales & Marketing',
    infraSecurity: 'Infrastructure & Security',
    opsSupport: 'Operations & Support'
  }
};
